<template>
  <v-container v-if="isVisible" fluid class="label">
    {{maintenanceText}}
    <v-icon
      small
    >report_problem</v-icon>
  </v-container>
</template>

<script>
export default {
    computed: {
        isVisible: function() {
            return false
        },
        maintenanceText: function() {
          return `Maintenance happens between X PM-Y PM on DATE (UTC)`
        }
    }
}
</script>

<style scoped>
.label {
  background-color: orange;
  color: #2c3e50;
  font-weight: bold;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/MaintenanceLabel.vue